import React, { Component } from 'react';
import { string, func } from 'prop-types';
import './InputPassword.scss';

export default class InputPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'password'
    }
    this.showHide = this.showHide.bind(this);
  }
  showHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === 'text' ? 'password' : 'text'
    });
  }
  render() {
    const { placeholder, onChange, type, value, className, formControl=true, ...other } = this.props
    return (
      <span className="password">
        <input
          className={`${formControl ? 'form-control' : ''} ${className}`}
          placeholder={placeholder}
          type={this.state.type}
          onChange={onChange}
          value={value}
          {...other}
        />
        <span className="password__show" onClick={this.showHide}>
          {this.state.type === 'text' ? 
          <i className="material-icons" role="button">visibility</i>
          : 
          <i className="material-icons" role="button">visibility_off</i>
          }
        </span>
      </span>
    )
  }
}

InputPassword.propTypes = {
  placeholder: string,
  onChange: func
};

InputPassword.defaultProps = {
  placeholder: 'Passwords must be at least 6 characters long',
  type: 'password',
  onChange: () => { }
};
